import { Link } from 'gatsby'
import React from 'react'
// export default ( { to, className, children, style } ) => <AniLink style={style} fade duration={0.4} to={to} className={className}>{children}</AniLink>

export default ( { to, className, children, style, onClick } ) => {
    if( to === null || to === "#" )
        return <a onClick="return false;" style={style} href="javascript:void(0);" className={`${className} empty-href`}>{children}</a>
    else
        return <Link onClick={onClick} style={style} to={to} className={className}>{children}</Link>
}